// tslint:disable
import { debounceTime, filter } from 'rxjs/operators';
import {
  AfterViewInit,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  Inject,
  Input,
  ViewContainerRef,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { BaseMapComponent } from '../../common/base-map/base-map.component';
import { HttpClient } from '../../common/http.client';
import { MapContextService } from 'app/common/map-context.service';
import { HistoricContextService } from 'app/historic/historic-context.service';
import { Subscription } from 'rxjs/Subscription';
import { BaseLayerDeck } from '../../common/layers/baseLayerDeck';
import { LayerService } from '../../common/services/layer.service';
import { LAYERS_ID } from '../layers/constants';
import { AMBService } from '../../services/amb.service';
import { ComponentLoaderService } from 'app/common/component-loader.service';
import { JamServiceLevelLayer } from '../layers/jamServiceLevelLayer';
import { ClusterServiceLevelLayer } from '../layers/clusterServiceLevelLayer';
import { JamDurationLayer } from '../layers/jamDurationLayer';
import { ClusterDurationLayer } from '../layers/clusterDurationLayer';
import { JamTrafficIntensityLayer } from '../layers/jamTrafficIntensityLayer';
import { ClusterTrafficIntensityLayer } from '../layers/clusterTrafficIntensityLayer';
import { EditableLayer } from '../layers/editableLayer';
import { POI_TYPES } from '../layers/constants'
import { CITY } from '../../common/const';
import { MvtService } from '../../common/services/mvt.service';
import { VIEW_MODES } from '../../real-time/real-time/real-time.component';
import {WebMercatorViewport} from '@deck.gl/core';
// tslint:enable

@Component({
  selector: 'app-historic-map',
  templateUrl: './historic-map.component.html',
  styleUrls: ['./historic-map.component.scss'],
})
export class HistoricMapComponent
  extends BaseMapComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('mapContainer') mapContainer;
  @ViewChild('zoomIn') zoomIn: ElementRef;
  @ViewChild('zoomOut') zoomOut: ElementRef;
  @ViewChild('home') home: ElementRef;
  @ViewChild('select') select: ElementRef;
  @Input() filters: any;
  @Input() hasHours;
  @Input() fromHour;
  @Input() toHour;
  @Input() variable;
  @Input() bypass;

  @Output() viewPort = new EventEmitter<any>();
  @Output() blockFilters = new EventEmitter<boolean>();
  @Output() click = new EventEmitter<any>();

  loading = true;
  filterHours = false;
  selectedVariable: any = { id: 1, name: 'Nivel de servicio', type: 'variable' };
  selected = false;
  editing = false;
  blocked = false;
  icon_mapping: any;
  icon_atlas: string;
  customBBOX = [];
  firstLoad = true;

  protected layers: {
    [layer_id: string]: { layer: BaseLayerDeck; modes: string[] };
  };
  protected subscription: Subscription;
  protected layersLoaded;

  constructor(
    private viewContainer: ViewContainerRef,
    private http: HttpClient,
    private ambService: AMBService,
    protected mapContext: MapContextService,
    private layerService: LayerService,
    protected ngZone: NgZone,
    @Inject(CITY) protected city,
    protected mvtService: MvtService,
    private componentLoaderService: ComponentLoaderService,
    private historicContextService: HistoricContextService
  ) {
    super(mapContext, ngZone);
    this.mvtService.getIconAtlas().then(i => {
        this.icon_atlas = i.atlas;
        this.icon_mapping = i.mapping;
    });
  }

  ngOnInit() {
    super.ngOnInit();
    POI_TYPES.map((x) => x.checked = true)
    this.historicContextService.setFilters({
      fromDate: null,
      toDate: null,
      hour: false,
      fromHour: null,
      toHour: null,
      variable: {id: 1, name: 'Nivel de servicio', type: 'variable'},
      bbox: null,
      bypass: false,
      custom: false,
      customBBOX: [],
      type: POI_TYPES
    });

    this.layersLoaded = false;
    // Filter by options defined in environment
    this.mapContext.listenerLayerLoading.subscribe((e: Array<any>) => {
      if (e.length) {
        this.loading = false;
      }
    });
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = new Subscription();
    this.subscription.add(
      this.mapContext.elementsForPopup$
        .pipe(debounceTime(200))
        .subscribe((popups) => this.openPopup(popups))
    );
    this.subscription.add(
      this.mapContext.onViewRender
        .pipe(debounceTime(500))
        .subscribe(() => this.updateCluster())
    );
    this.subscription.add(
      this.mapContext.currentMapEvent
        .pipe(debounceTime(0))
        .subscribe(() => this.updateClick())
    );

    this.map.on('load', () => {});
  }

  updateComponentView(mode, source, categories) {}

  ngOnChanges(changes) {
    let hasFilterChange = false;
    const filters = this.historicContextService.getFilters();

    // Select hours
    if (changes.hasOwnProperty('hasHours')) {
      filters.hour = changes.hasHours.currentValue;
      // Reset hours on toggle off
      if (!filters.hour) {
        filters.fromHour = undefined;
        filters.toHour = undefined;
        // Toggle off from hours selection
        if (filters.hour === false) {
          hasFilterChange = true;
        }
      }
    }
    // Hour from selection
    if (changes.hasOwnProperty('fromHour')) {
      filters.fromHour = changes.fromHour.currentValue;

      if (filters.hour && filters.toHour) {
        hasFilterChange = true;
      }
    }
    // Hour to selection
    if (changes.hasOwnProperty('toHour')) {
      filters.toHour = changes.toHour.currentValue;

      if (filters.hour && filters.fromHour) {
        hasFilterChange = true;
      }
    }
    // Date range selection
    if (changes.filters && changes.filters.currentValue) {
      const event = changes.filters.currentValue;

      if (event.beginDate) {
        filters.fromDate = event.beginDate;
        filters.toDate = event.endDate;
        hasFilterChange = true;
      }
    }
    // Filter variable
    if (changes.variable) {
      filters.variable = changes.variable.currentValue;
      if (!changes.variable.firstChange) {
        this.selectedVariable = filters.variable;
        hasFilterChange = true;
      }
    }
    // Filter bypass
    if (changes.hasOwnProperty('bypass') && 'undefined' !== typeof(changes.bypass.currentValue)) {
      filters.bypass = changes.bypass.currentValue;
      hasFilterChange = true;
      if (filters.bypass) {
        this.mapContext.flyTo([2.154007, 41.390205]);
      }
    }

    this.historicContextService.setFilters(filters);

    if (hasFilterChange) {
      this.blockFilters.emit(false);
      this.filterData()
    }
  }
  /**
   * Update type to filter pois on click legend
   * @param $event
   */
  receiveType($event) {
    const filters = this.historicContextService.getFilters();
    filters.type.find(x => x.id === $event.id).checked = $event.value;
    this.updateCluster(true)
  }
  filterData() {
    this.loading = true;
    this.removePopup();
    this.selected = false;
    if (this.historicContextService.getFilters().custom) {
      this.initDataLayers();
    } else {
      // Wait to load icon atlas from MTV on first load
      if (this.firstLoad) {
        setTimeout(() => { this.initLayers(); this.firstLoad = false }, 200);
      } else {
        this.initLayers();
      }
    }
  }

  removePopup() {
    this.mapContext.closePopup();
  }

  initDataLayers() {
    const layers: any[] = this.getLayers();
    this.layers = {};
    layers.forEach((l) => {
      if (l.layer.id !== LAYERS_ID.WAZE_BCN_EDITABLE_LAYER
        && l.layer.id !== LAYERS_ID.WAZE_BCN_EDITABLE_GEOJSON_LAYER
        && l.layer.id !== LAYERS_ID.WAZE_BCN_EDITABLE_SCARLET_LAYER
        && l.layer.id !== LAYERS_ID.WAZE_BCN_EDITABLE_TEXT_LAYER
      ) {
        this.layers[l.id] = {
          layer: this.layerService.addLayer(l.layer, true, l.underLayerId),
          modes: l.modes,
        };

        // Feature cursor style
        this.subscription.add(
          this.layers[l.id].layer.onHover
            .pipe(debounceTime(10))
            .subscribe((hover) => {
              this.mapContext.deckInstance.setProps({
                getCursor: () => (hover ? 'pointer' : ''),
              });
            })
        );
      }
    });

  }

  initLayers() {

    const layers: any[] = this.getLayers();
    this.layers = {};
    layers.forEach((l) => {
      this.layers[l.id] = {
        layer: this.layerService.addLayer(l.layer, true, l.underLayerId),
        modes: l.modes,
      };

      // Feature cursor style
      this.subscription.add(
        this.layers[l.id].layer.onHover
          .pipe(debounceTime(10))
          .subscribe((hover) => {
            this.mapContext.deckInstance.setProps({
              getCursor: () => (hover ? 'pointer' : ''),
            });
          })
      );
    });

  }

  removeLayers() {
    const layers: any[] = this.getLayers();
    this.layers = {};
    layers.forEach((l) => {
      this.layerService.removeLayer(l.layer.id);
    });
  }

  removeDataLayers() {
    const layers: any[] = this.getLayers();
    this.layers = {};
    layers.forEach((l) => {
      if (l.layer.id !== LAYERS_ID.WAZE_BCN_EDITABLE_LAYER
        && l.layer.id !== LAYERS_ID.WAZE_BCN_EDITABLE_GEOJSON_LAYER
        && l.layer.id !== LAYERS_ID.WAZE_BCN_EDITABLE_SCARLET_LAYER
        && l.layer.id !== LAYERS_ID.WAZE_BCN_EDITABLE_TEXT_LAYER
        ) {
        this.layerService.removeLayer(l.layer.id);
      }
    });
  }

  getLayers() {
    // Detach layers before add news
    if (this.layers) {
      Object.keys(this.layers).forEach((id) => {
        if (id !== LAYERS_ID.WAZE_BCN_EDITABLE_LAYER
          && id !== LAYERS_ID.WAZE_BCN_EDITABLE_GEOJSON_LAYER
          && id !== LAYERS_ID.WAZE_BCN_EDITABLE_SCARLET_LAYER
          && id !== LAYERS_ID.WAZE_BCN_EDITABLE_TEXT_LAYER
          ) {
            try {
              this.layerService.removeLayer(id);
            } catch (ex) {}
          }
      });
    }
    let layers = [];

    switch (this.selectedVariable.id) {
      // Duration
      case 3:
        layers = [
          {
            id: LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_LAYER,
            layer: new JamTrafficIntensityLayer(
              this.city,
              this.mvtService,
              this.historicContextService.getFilters()
            ),
            modes: [VIEW_MODES.LIVE],
          },
          {
            id: LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_LAYER_GEOJSON,
            layer: new ClusterTrafficIntensityLayer(
              this.city,
              this.mvtService,
              this.historicContextService.getFilters(),
              this.icon_atlas,
              this.icon_mapping
            ),
            modes: [VIEW_MODES.LIVE],
          },
        ];
        break;
      // Duration
      case 2:
        layers = [
          {
            id: LAYERS_ID.WAZE_BCN_DURATION_LAYER,
            layer: new JamDurationLayer(
              this.city,
              this.mvtService,
              this.historicContextService.getFilters()
            ),
            modes: [VIEW_MODES.LIVE],
          },
          {
            id: LAYERS_ID.WAZE_BCN_DURATION_LAYER_GEOJSON,
            layer: new ClusterDurationLayer(
              this.city,
              this.mvtService,
              this.historicContextService.getFilters(),
              this.icon_atlas,
              this.icon_mapping
            ),
            modes: [VIEW_MODES.LIVE],
          },
        ];
        break;
      // Default Service level variable
      default:
        layers = [
          {
            id: LAYERS_ID.WAZE_BCN_SERVICE_LEVEL_LAYER,
            layer: new JamServiceLevelLayer(
              this.city,
              this.mvtService,
              this.historicContextService.getFilters()
            ),
            modes: [VIEW_MODES.LIVE],
          },
          {
            id: LAYERS_ID.WAZE_BCN_SERVICE_LEVEL_LAYER_GEOJSON,
            layer: new ClusterServiceLevelLayer(
              this.city,
              this.mvtService,
              this.historicContextService.getFilters(),
              this.icon_atlas,
              this.icon_mapping
            ),
            modes: [VIEW_MODES.LIVE],
          },
        ];
    }
    layers.push({
      id: LAYERS_ID.WAZE_BCN_EDITABLE_LAYER,
      layer: new EditableLayer(this.historicContextService),
      modes: [VIEW_MODES.ROUTES],
    });
    return layers;
  }

  getZoom() {
    return this.mapContext.mapInstance.getZoom();
  }

  ngAfterViewInit() {
    this.zoomIn.nativeElement.onclick = this.zoomInFn.bind(this);
    this.zoomOut.nativeElement.onclick = this.zoomOutFn.bind(this);
    this.home.nativeElement.onclick = this.homeFn.bind(this);
    this.select.nativeElement.onclick = this.selectFn.bind(this);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    // Clean filters
    this.historicContextService.setFilters({
      fromDate: null,
      toDate: null,
      hour: false,
      fromHour: null,
      toHour: null,
      variable: 1,
      bbox: null,
      bypass: false
    });

    this.removeLayers();
  }

  zoomInFn() {
    this.mapContext.zoomIn();
  }

  zoomOutFn() {
    this.mapContext.zoomOut();
  }

  homeFn() {
    this.mapContext.flyTo([2.154007, 41.390205]);
  }

  selectFn() {
    const filters = this.historicContextService.getFilters();
    this.selected = !this.selected;
    this.editing = this.selected;
    filters.custom = this.selected;
    if (this.selected) {
      this.removeDataLayers();
      this.blockFilters.emit(true);
    } else {
      this.initDataLayers();
      this.layerService.getLayer(LAYERS_ID.WAZE_BCN_EDITABLE_LAYER).updateSource(null);
      this.blocked = false;
    }

    this.historicContextService.setFilters(filters);
  }

  stopEdit() {
    this.blockFilters.emit(false);
    this.viewPort.emit(this.mapContext._bbox);
    this.filterData();
    this.initDataLayers();
    this.blocked = true;
  }

  updateCluster(force = false) {
    // tslint:disable
    if (this.selectedVariable.id === 1 && this.layerService.hasLayer(LAYERS_ID.WAZE_BCN_SERVICE_LEVEL_LAYER_GEOJSON)) {
      this.layerService.getLayer(LAYERS_ID.WAZE_BCN_SERVICE_LEVEL_LAYER_GEOJSON).updateCluster(this.mapContext.mapInstance.getZoom(), force);
    } else if (this.selectedVariable.id === 2 && this.layerService.hasLayer(LAYERS_ID.WAZE_BCN_DURATION_LAYER_GEOJSON)) {
      this.layerService.getLayer(LAYERS_ID.WAZE_BCN_DURATION_LAYER_GEOJSON).updateCluster(this.mapContext.mapInstance.getZoom(), force);
    } else if (this.selectedVariable.id === 3 && this.layerService.hasLayer(LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_LAYER_GEOJSON)) {
      this.layerService.getLayer(LAYERS_ID.WAZE_BCN_TRAFFIC_INTENSITY_LAYER_GEOJSON).updateCluster(this.mapContext.mapInstance.getZoom(), force);
    }
    // tslint:enable

    // Emit bbox change to historic component for change sidebar data
    if (!this.selected) {
      this.viewPort.emit(this.mapContext._bbox);
      this.selected = this.blocked;
    }
  }

  updateClick() {
    const filters = this.historicContextService.getFilters();
    if (filters.custom && !this.blocked) {
      this.click.emit(this.mapContext.currentMapEvent);
      this.layerService.getLayer(LAYERS_ID.WAZE_BCN_EDITABLE_LAYER).updateSource(this.mapContext._coordinates);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/historic/historic-map/historic-map.component.ts